import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import MoleculeCheckBox from "../../Molecule/MoleculeCheckBox";
import { CONST_TOOLTIP, IDLE_TIMEOUT } from "../../constants/Common";
import usePlayerEquipment from "../../hooks/usePlayerEquipment";
import { findDropItemByIdCfg } from "../../utils/common";
import { postSellEquipments, postStopSellEquipments } from "../../services/authService";
import useRemoveEquipment from "../../hooks/useRemoveEquipment";
import { toast } from "react-toastify";
import { DANG_SELL_EQUIPMENT, DONE_SELL_EQUIPMENT } from "../../constants/errMessage";
import { TOAST_TYPE, updateToastPromise } from "../../contexts/ToastProvider";
const PlayerSellEquipments = ({ playerId }) => {
    const { equipments } = usePlayerEquipment(playerId);
    const [sellEquipments, setSellEquipments] = useState([]);
    const [idTimer, setIdTimer] = useState(null);
    const [isSelling, setIsSelling] = useState(false);
    const [toastPromiseId, setToastPromiseId] = useState(null);
    const { rmEquipments } = useRemoveEquipment();
    const [isExistItemForSell, setIsExistItemForSell] = useState(false);

    const updateSellEquipment = (idCfg, newChecked) => {
        // console.log('updateSellEquipment', idCfg, newChecked)
        // console.log('updateSellEquipment2', sellEquipments, sellEquipments.includes(idCfg))
        if (newChecked === true) {
            if (sellEquipments.includes(idCfg)) return;
            const newSellEquipments = sellEquipments.concat(idCfg);
            // console.log('updateSellEquipment', newSellEquipments)
            setSellEquipments(newSellEquipments);
        } else {
            const newSellEquipments = sellEquipments.filter(id => id !== idCfg);
            // console.log('updateSellEquipment', newSellEquipments)
            setSellEquipments(newSellEquipments);
        }
    }

    const clearAll = () => {
        setSellEquipments([]);
    }

    const selectAll = () => {
        const newSellEquipments = []
        Object.entries(equipments).forEach(([key, value]) => {
            const item = findDropItemByIdCfg(Number(key), 2);
            if (item && value > 0) newSellEquipments.push(Number(key))
        })
        setSellEquipments(newSellEquipments);
    }

    const handleSellEquipment = (e) => {
        e.preventDefault();
        if (isSelling === true) return;
        setIsSelling(true);
        clearTimeout(idTimer);
        const _idTimer = setTimeout(() => {
            setIsSelling(false);
        }, IDLE_TIMEOUT.CLEAR_STATUS_SELL_EQUIPMENT);
        setIdTimer(_idTimer);
        // console.log('handleSellEquipment', sellEquipments);
        const res = postSellEquipments(playerId, sellEquipments);
        if (res.error == true) {
            setIsSelling(false);
            clearTimeout(_idTimer);
        }
    }

    const handleStopSellEquipment = () => {
        postStopSellEquipments(playerId);
    }

    useEffect(() => {
        if (rmEquipments[playerId] != null) {
            setIsSelling(true);
            clearTimeout(idTimer);
            const _idTimer = setTimeout(() => {
                setIsSelling(false);
            }, IDLE_TIMEOUT.CLEAR_STATUS_SELL_EQUIPMENT);
            setIdTimer(_idTimer);
            const item = findDropItemByIdCfg(Number(rmEquipments[playerId].idCfg), 2);
            const count = rmEquipments[playerId].count;
            if (item != null && count != null) {
                if (toastPromiseId == null) {
                    // console.log('new', toastPromiseId);
                    const toastId = toast.loading(`${DANG_SELL_EQUIPMENT}${item.label} (x${count})`);
                    setToastPromiseId(toastId);
                } else {
                    updateToastPromise(toastPromiseId, `${DANG_SELL_EQUIPMENT}${item.label} (x${count})`, TOAST_TYPE.INFO)
                }
                if (rmEquipments[playerId].count === 0) {
                    const newSellEquipments = sellEquipments.filter(id => id !== Number(rmEquipments[playerId].idCfg));
                    // console.log('updateSellEquipment', newSellEquipments)
                    setSellEquipments(newSellEquipments);
                }
            }
        }
        else {
            setIsSelling(false);
            clearTimeout(idTimer);
            updateToastPromise(toastPromiseId, DONE_SELL_EQUIPMENT, TOAST_TYPE.SUCCESS);
            setToastPromiseId(null);
        }
        return () => {
            setIsSelling(false);
            clearTimeout(idTimer);
            // updateToastPromise(toastPromiseId, '', TOAST_TYPE.DEFAULT);
            // setToastPromiseId(null);
        }
    }, [rmEquipments[playerId]])

    useEffect(() => {
        const newSellEquipments = [];
        sellEquipments.forEach(idCfg => {
            if (equipments[idCfg] != null && equipments[idCfg] > 0) {
                newSellEquipments.push(idCfg);
            }
        });
        setSellEquipments(newSellEquipments);
    }, [])
    useEffect(() => {
        let isExist = false;
        for (const key in equipments) {
            // console.log(key)
            const item = findDropItemByIdCfg(Number(key), 2);
            if (item && equipments[key] > 0) {
                isExist = true
                break;
            }
        }
        setIsExistItemForSell(isExist);
    }, [equipments])

    return (
        <Row className="mt-2">
            {!isExistItemForSell && <div>Không có trang bị level 1 rớt từ phó bản để bán</div>}
            {isExistItemForSell && <Row className="mt-3">
                <Col>
                    <Button className="mx-auto" variant="outline-primary" size="sm" onClick={() => { clearAll() }}>Clear ALL</Button>
                </Col>
                <Col>
                    <Button className="mx-auto" variant="outline-primary" size="sm" onClick={() => { selectAll() }}>Select ALL</Button>
                </Col>
            </Row>}
            {isExistItemForSell && <Form onSubmit={(e) => { handleSellEquipment(e) }}>
                <Row className="mt-3" >
                    <Col>
                        <Row xs={1} sm={2} md={3} lg={3}>
                            {
                                Object.entries(equipments).map(([idCfg, count]) => {
                                    const item = findDropItemByIdCfg(Number(idCfg), 2);
                                    if (item && count > 0) {
                                        return (<MoleculeCheckBox
                                            key={`MoleculeCheckBox-${item.label}`}
                                            label={`${item.label} (x${count})`}
                                            tooltip={CONST_TOOLTIP.SELL_EQUIPMENTS}
                                            value={sellEquipments.includes(Number(idCfg))}
                                            onChange={(newChecked) => updateSellEquipment(Number(idCfg), newChecked)}
                                        />)
                                    }
                                })
                            }
                        </Row>
                    </Col>
                    <Col xs={3} sm={2} md={2} lg={1} className="d-flex align-items-center">
                        {!isSelling && <Button className="mx-auto" variant="danger" type="submit">Bán</Button>}
                        {isSelling && <Button className="mx-auto" variant="success" onClick={() => { handleStopSellEquipment() }}>Dừng</Button>}
                    </Col>
                </Row>
            </Form>}
        </Row>

    );
}

export default PlayerSellEquipments
